import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../../../primitives/Tab/Panel/components/Container.js';
export const Panel = /*#__PURE__*/_styled(forwardRef((props, ref) => {
  return _jsx(Container, {
    ...props,
    ref: ref,
    role: "tabpanel"
  });
}), process.env.NODE_ENV === "production" ? {
  target: "eji1xtm0"
} : {
  target: "eji1xtm0",
  label: "Panel"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBhbmVsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1JIiwiZmlsZSI6IlBhbmVsLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3ggfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL1RhYi9QYW5lbC9jb21wb25lbnRzL0NvbnRhaW5lci5qcyc7XG5leHBvcnQgY29uc3QgUGFuZWwgPSBzdHlsZWQoZm9yd2FyZFJlZigocHJvcHMsIHJlZikgPT4ge1xuICAgIHJldHVybiBfanN4KENvbnRhaW5lciwgeyAuLi5wcm9wcywgcmVmOiByZWYsIHJvbGU6IFwidGFicGFuZWxcIiB9KTtcbn0pKSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVBhbmVsLmpzLm1hcCJdfQ== */");